import styles from "./ActionScreenDefineProducedProductParameterizedVariableValues.module.scss";
import ActionScreenTopBar from "../Components/ActionScreenTopBar";
import { useEffect, useState } from "react";
import HxfSelectorField from "../../../../HxfSelectorField/HxfSelectorField";
import { useActionScreenManagerStore } from "../../ActionScreensManager/ActionScreenManagerStore";
import {
  dispatchActionScreenDefineProducedProductParameterizedVariableValuesStore,
  useActionScreenDefineProducedProductParameterizedVariableValuesStore,
} from "./ActionScreenDefineProducedProductParameterizedVariableValuesStore";
import { FormControl, InputLabel, Select, TextField } from "@mui/material";
import { IonButton } from "@ionic/react";
import confirmationStyles from "../Components/ActionScreenConfirmationButton.module.scss";
import { useProductionOrderSelectionStore } from "../../../../../FeaturePages/ProductionOrders/Standard/store/productionOrderSelectionStore";
import { t } from "i18next";
import useHxfTranslation from "../../../../../../barrel/hooks/useHxfTranslation";
import DefineProductParameterizedVariableValuesPopup from "../../../../statePopups/defineProductParameterizedVariableValues/DefineProductParameterizedVariableValuesPopup";
interface IResult {
  parameterizedVariablesData: Array<any>;
}
function ActionScreenDefineProducedProductParameterizedVariableValues(
  props: any
) {
  const [indexkey, setIndexkey] = useState(0);
  const currentActionScreenManager = useActionScreenManagerStore();
  const [didMount, setDidMount] = useState(false);
  const actionScreenDefineProducedProductParameterizedVariableValuesStore =
    useActionScreenDefineProducedProductParameterizedVariableValuesStore();
  const {t} = useHxfTranslation();
  const productionOrderSelectionStore = useProductionOrderSelectionStore();


  const getProperData = () => {
   const ONLY_ASK_FOR_NOT_DEFINED_PPVVS = true; //todo make a flag and set enabled by default (AML)

   let idProduct = productionOrderSelectionStore?.product?.Id;
   let productCode = productionOrderSelectionStore?.product?.code;
   let productName = productionOrderSelectionStore?.product?.name;
   let productionOrderProduct_ParameterizedVariableValues = JSON.parse(JSON.stringify(productionOrderSelectionStore?.productionOrderProduct_ParameterizedVariableValues));

   let arrayProductParameterizedVariables = [];
    if(productionOrderProduct_ParameterizedVariableValues){
      for(let i = 0; i<productionOrderProduct_ParameterizedVariableValues.length; i++){
        let value = productionOrderProduct_ParameterizedVariableValues[i]?.Value;
        if(ONLY_ASK_FOR_NOT_DEFINED_PPVVS){
          let isValueNotDefined = !value || value === undefined || value === "";
          if(!isValueNotDefined){
            productionOrderProduct_ParameterizedVariableValues[i]._hideThisPV = true;
          }
        }
      }

      arrayProductParameterizedVariables = productionOrderProduct_ParameterizedVariableValues;
    }

   
    return {
      Id_Product:idProduct,
      name:productName,
      code:productCode,
      arrayProductParameterizedVariables:arrayProductParameterizedVariables
    };
  }
  useEffect(() => {
    console.log(
      "CUR ACT CFG: ",
      currentActionScreenManager.currentActionConfig
    );
    console.log(
      "CUR Local comp state: ",
      actionScreenDefineProducedProductParameterizedVariableValuesStore
    );
    if (!didMount) {
      setDidMount(true);
    }
  }, [
    didMount,
    currentActionScreenManager.currentActionConfig,
    actionScreenDefineProducedProductParameterizedVariableValuesStore,
  ]);

  console.log("Cur act s m", currentActionScreenManager.currentActionConfig);

  if (
    !currentActionScreenManager?.currentActionConfig
      ?.temp_parameterizedVariables
  ) {
    return <></>;
  }

  return (
    <>
      <DefineProductParameterizedVariableValuesPopup
         currentData={getProperData()}
         allowIncompleteFilledList={false}
         allowCurrentDataValuesLoad={true}
         includeFullParameterizedVariablesData={true}
         title={t('define.product.variables')}
         onClosePopup={() => {
          props?.callbackOnClose();
             
         }}
         onSuccessConfirm={(res:any) => {
          let newDefinedPPVVS = res;
          //clear unneeded flags
          for(let i = 0; i<newDefinedPPVVS.length; i++){
            delete newDefinedPPVVS[i]._hideThisPV;
          }

          dispatchActionScreenDefineProducedProductParameterizedVariableValuesStore({
            type:"SET_DEFINED_VARIABLES", payload:newDefinedPPVVS
          });

          props.callbackSuccessConfirm({
            arrayProductParameterizedVariables:newDefinedPPVVS
          });
  
         }}
      />
    </>
  )

  return (
    <>
      <div className={styles.container}>
        <ActionScreenTopBar
          callbackOnClose={props.callbackOnClose}
          title={t('define.product.variables')}
        />

        <div className={styles.content}>
          <div className={styles.label}>{t('define.the.variables')}</div>
          <div className={styles.productVariablesSection}>
            <div className={styles.productVariables}>

            </div>
          </div>

          <div className={confirmationStyles.confirmationContainer}>
            <IonButton
              className={confirmationStyles.confirmButton}
              onClick={() => {
                /*let storeResult = confirmProductParameterizedVariables();

                if (storeResult !== false) {
                  props.callbackSuccessConfirm(storeResult);
                }*/
              }}
            >
              {t("confirm.caps")}
            </IonButton>
          </div>
        </div>
      </div>
    </>
  );
}

export default ActionScreenDefineProducedProductParameterizedVariableValues;
